import MobileStepper from '@material-ui/core/MobileStepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Stepper from '@material-ui/core/Stepper'
import withWidth from '@material-ui/core/withWidth'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'

function NewStepper(props) {
  const { activeStep, className, headercolour, headertextcolour, labelClass, steps, width } = props
  return (
    <ThemeProvider theme={theme}>
      {width !== 'xs' ? (
        <ModalSteps
          className={className}
          activeStep={activeStep}
          connector={null}
          headercolour={headercolour}
          headertextcolour={headertextcolour}
        >
          {steps.map(stepLabel => (
            <Step key={stepLabel}>
              <StyledStepLabel
                headertextcolour={headertextcolour}
                headercolour={headercolour}
                classes={{
                  active: 'active',
                  completed: 'completed',
                  label: 'label',
                }}
                className={labelClass}
                StepIconProps={{
                  classes: {
                    root: 'rootIcon',
                    active: 'activeIcon',
                    completed: 'completedIcon',
                  },
                }}
              >
                {stepLabel}
              </StyledStepLabel>
            </Step>
          ))}
        </ModalSteps>
      ) : (
        <MobileContainer
          style={{ backgroundColor: headercolour }}
          headercolour={headercolour}
          headertextcolour={headertextcolour}
        >
          <div className="mobileLabel">{steps[activeStep]}</div>
          <MobileSteps
            classes={{
              dot: 'dot',
              dotActive: 'dotActive',
            }}
            variant="dots"
            position="static"
            activeStep={activeStep}
            steps={steps.length}
            headercolour={headercolour}
            headertextcolour={headertextcolour}
          />
        </MobileContainer>
      )}
    </ThemeProvider>
  )
}

const ModalSteps = styled(Stepper)`
  && {
    background-color: ${props => props.theme.stepper.stepperBackground};
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ headercolour }) => headercolour && `background-color: ${headercolour}`};
  }
`

const MobileSteps = styled(MobileStepper)`
  && {
    background-color: ${props => props.theme.stepper.stepperBackground};
    padding: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    ${({ headercolour }) => headercolour && `background-color: ${headercolour}`};
    .dot,
    .dotActive {
      background-color: ${props => props.theme.stepper.stepperForeground};
      opacity: 0.5;
      ${({ headertextcolour }) => headertextcolour && `background-color: ${headertextcolour}`};
    }
    .dotActive {
      opacity: 1;
    }
  }
`

const StyledStepLabel = styled(StepLabel)`
  && {
    .active,
    .completed,
    .label {
      color: ${props => props.theme.stepper.stepperForeground};
      opacity: 0.7;
      font-size: ${props => props.theme.typography.fontSizeSm};
      ${({ headertextcolour }) => headertextcolour && `color: ${headertextcolour}`};
    }
    .active {
      opacity: 1;
    }
    .rootIcon {
      fill: ${props => props.theme.stepper.stepperBackground};
      opacity: 0.7;
      box-shadow:
        0 0 1px 0px ${props => props.theme.stepper.stepperForeground} inset,
        0 0 1px 0px ${props => props.theme.stepper.stepperForeground};
      border: 1px solid ${props => props.theme.stepper.stepperForeground};
      ${({ headercolour }) => headercolour && `fill: ${headercolour}`};
      ${({ headertextcolour }) =>
        headertextcolour &&
        `box-shadow: 0 0 1px 0 ${headertextcolour} inset, 0 0 1px 0 ${headertextcolour}; border-color: ${headertextcolour}`};
      > text {
        fill: ${props => props.theme.stepper.stepperForeground};
        ${({ headertextcolour }) => headertextcolour && `fill: ${headertextcolour}`};
      }
    }
    .activeIcon,
    .completedIcon {
      fill: ${props => props.theme.stepper.stepperForeground};
      opacity: 1;
      border: none;
      border-radius: 0;
      box-shadow: none;
      ${({ headertextcolour }) => headertextcolour && `fill: ${headertextcolour}`};
    }
    .activeIcon {
      font-weight: bold;
      > text {
        fill: ${props => props.theme.stepper.stepperBackground};
        ${({ headercolour }) => headercolour && `fill: ${headercolour}`};
      }
    }
  }
`

const MobileContainer = styled.div`
  background-color: ${props => props.theme.stepper.stepperBackground};
  padding: ${props => props.theme.spacing(4)};
  color: ${props => props.theme.stepper.stepperForeground};
  ${({ headercolour }) => headercolour && `background-color: ${headercolour}`};
  ${({ headertextcolour }) => headertextcolour && `color: ${headertextcolour}`};
  .mobileLabel {
    text-align: center;
    font-size: ${props => props.theme.typography.fontSizeSm};
  }
`

const FormStepper = withWidth()(NewStepper)
FormStepper.displayName = 'Stepper'
export default FormStepper
